const removeWhiteSpace = (string) => {
  return string.replace(/\s/g, "");
};

const generateRandomId = () => {
  return Math.random().toString(36).substring(2, 7);
};

const slugify = (title) => {
  if (!title) return "";

  return title
    .toLowerCase()
    .normalize("NFD") // Remove accents (diacritics)
    .replace(/[\u0300-\u036f]/g, "") // Strip diacritics
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
    .trim() // Trim leading/trailing spaces
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-"); // Collapse multiple hyphens
};

const trimText = (text, characterCount) => {
  const trimTo = (str) =>
    str.length > characterCount ? str.substring(0, characterCount) + "…" : str;

  return trimTo(text);
};

module.exports = { removeWhiteSpace, generateRandomId, slugify, trimText };
